export const BOOKS_ACTIONS = {
  SAVE_CATEGORY: "save_category",
  SAVE_BOOKS_DATA: "save_books_data",
  SAVE_CART: "save_cart",
  SAVE_WISHLIST: "save_wishlist",
  WISHLISTED: "wishlisted",
  REMOVE_WISHLISTED: "remove_wishlisted",
  ADD_TO_CART: "add_to_cart",
  REMOVE_FROM_CART: "remove_from_cart",
  RESET_CART_WISHLIST:"reset_cart_wishlist",
  RESET:"reset",
  RESET_PRODUCTS:"reset_products",
  SAVE_PURCHASED_ITEMS:"save_purchased_items"
};

export const FILTERS_ACTION ={
  RESET:"reset",
  CHANGE_PRICE_SORT:"change_price_sort",
  UPDATE_CATEGORY:"update_category",
  UPDATE_PRICE_SLIDER:"update_price_slider",
  UPDATE_RATING_SLIDER:"update_rating_slider",

}